export const FORTY_FIVE_DAYS_AGO = new Date(Date.now() - 45 * 24 * 60 * 60 * 1000); // 45th day from current day and time
export const CALENDAR_MAX_DATE = "2099-12-31";
